import { NavigationProp, RouteProp, useNavigation, useRoute } from '@react-navigation/native'
import { FlatList, Text, TouchableOpacity, View } from 'react-native'

import { useContext, useEffect, useState } from 'react'

import { CheckBox } from '../../../components/CheckBox'
import { Separator } from '../../../components/Separator'
import { TemplatePage } from '../../../components/TemplatePage'
import { InitialInputVoiceSearch } from '../../../components/VoiceSearch/InitialInput/InitialInput'
import { Option } from '../../../context/FreshWater/types'
import { ControlServicesContext } from '../../../context/SeaWater/ControlServices/ControlServicesContext'
import { buttonStyle } from '../../../theme/buttons'
import { globalStyle } from '../../../theme/global'
import { Detail } from '../../../types'
import { useTranslation } from 'react-i18next'
import { ControlServicesRoutes } from '../../../navigator/types'
import { disabledGray, textColor } from '../../../theme/colors'

const DEFAULT_OPTION = 0
interface ValuesCage {
  [key: string]: { checked: boolean; cageId: number }
}
interface Navigation extends NavigationProp<ControlServicesRoutes, 'CategoryFour'> {}
export const CategoryFour = () => {
  const { t } = useTranslation()
  const [search, setSearch] = useState('')
  const { cages } = useContext(ControlServicesContext)
  const { navigate } = useNavigation<Navigation>()
  const route = useRoute<RouteProp<ControlServicesRoutes, 'CategoryFour'>>()
  const { centerId, detail } = route.params
  const [filteredData, setFilteredData] = useState<Option[]>([])

  const [values, setValues] = useState<ValuesCage>(() => {
    if (!detail) return {}
    return Object.fromEntries(
      detail.map((item) => [item.idCage, { checked: true, cageId: item.idCage }]),
    )
  })
  const [allSelected, setAllSelected] = useState(false)

  useEffect(() => {
    setFilteredData([
      { id: DEFAULT_OPTION, name: t('NO SELECCIONAR JAULAS') },
      ...cages[centerId]!.filter((cage) => cage.name.toLowerCase().includes(search.toLowerCase())),
    ])
  }, [search])

  useEffect(() => {
    if (cages[centerId]!.length === Object.values(values).filter((value) => value.checked).length) {
      setAllSelected(true)
    }
  }, [values])

  const handleSetValue = (item: Option) => {
    setValues((oldValues) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [DEFAULT_OPTION]: toDelete, ...rest } = oldValues
      setAllSelected(false)

      return {
        ...rest,
        [item.id]: {
          checked: !oldValues[item.id]?.checked,
          cageId: item.id,
        },
      }
    })
  }

  const handleCleanSelected = () =>
    setValues((oldValues) => {
      setAllSelected(false)
      return {
        [DEFAULT_OPTION]: {
          cageId: DEFAULT_OPTION,
          checked: !oldValues[DEFAULT_OPTION]?.checked,
        },
      }
    })

  const handleAllSelected = () => {
    setAllSelected(true)
    setValues(() =>
      Object.fromEntries(
        cages[centerId]!.map(({ id }) => [
          id,
          {
            cageId: id,
            checked: true,
          },
        ]),
      ),
    )
  }

  const handleDisabled = () => !Object.values(values).some((val) => val.checked)

  const handleNavigate = () => {
    const detail: Detail[] = Object.values(values)
      .filter((val) => val.checked && val.cageId !== 0)
      .map((item) => ({
        idCage: item.cageId,
        m2: null,
        nameCage: null,
        operator: null,
        rov: null,
      }))

    navigate('FinalForm', { ...route.params, detail })
  }

  return (
    <TemplatePage
      styleContent={{ padding: 0, marginBottom: 0 }}
      header
      title={route.params.namePage.toUpperCase()}
    >
      <View style={globalStyle.viewContainer}>
        <InitialInputVoiceSearch
          placeholder={t('BUSCAR JAULA')}
          getSearchValue={(value) => setSearch(value)}
          hasInput
        />

        <FlatList
          style={{ marginTop: 15 }}
          data={filteredData}
          ListHeaderComponent={() => (
            <View
              style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 15 }}
            >
              <View style={{ flex: 1, justifyContent: 'center' }}>
                <Text style={{ fontWeight: 'bold', color: textColor }}>{t('JAULAS')}</Text>
              </View>
              <View style={{ flex: 0.9 }}>
                <CheckBox
                  isCheck={allSelected}
                  item={{ id: 1, name: t('Seleccionar Todas') }}
                  onPress={handleAllSelected}
                  invertLabel
                />
              </View>
            </View>
          )}
          renderItem={({ item }) => (
            <View style={{ flex: 3, marginTop: 10 }}>
              <CheckBox
                isCheck={values[item.id]?.checked ?? false}
                item={item}
                onPress={() => {
                  if (item.id === 0) {
                    handleCleanSelected()
                    return
                  }

                  handleSetValue(item)
                }}
                invertLabel
              />
            </View>
          )}
          ItemSeparatorComponent={() => <Separator />}
        />

        <TouchableOpacity
          style={[
            buttonStyle.basic,
            handleDisabled() && { backgroundColor: disabledGray },
            { width: '100%', marginBottom: 10, marginTop: 20 },
          ]}
          onPress={handleNavigate}
          activeOpacity={0.7}
          disabled={handleDisabled()}
        >
          <Text style={buttonStyle.text}>{t('Continuar')}</Text>
        </TouchableOpacity>
      </View>
    </TemplatePage>
  )
}
